module.exports = __webpack_public_path__ + "static/img/info_t1.2100e7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/info_t1.jpg
// module id = P3O0
// module chunks = 101